// src/view/metrics/components/taps.js
import Dimerization from "./dimerization";
import { Graphics } from "./graphics";
import { Measurement } from "./measurements";
import { Thresholds } from "./thresholds";

export const itemsTaps = ({ t, device, data, lastMeasurement, loadingMeasurement }) => {
  if (!device) return;
  const items = [
    {
      key: 1,
      label: t("metrics.measurementTaps"),
      children: <Measurement device={device} lastMeasurement={lastMeasurement} loadingMeasurement={loadingMeasurement} />,
    },
    {
      key: 2,
      label: t("thresholds.title"),
      children: <Thresholds device={device} lastMeasurement={lastMeasurement} loadingMeasurement={loadingMeasurement} />,
    },
  ];

  return items;
};
